import { render, staticRenderFns } from "./Renters.vue?vue&type=template&id=5da4cd6e&"
import script from "./Renters.vue?vue&type=script&lang=js&"
export * from "./Renters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports